import React from 'react';

//결제 취소시 이컴포넌트로 리다이렉트
const CloseWindow = () => {
  window.close();
  return <></>;
};

export default CloseWindow;
